export enum CollectionSegment {
    Footwear = "Footwear",
    LeatherGoods = "LeatherGoods",
    Accessories = "Accessories",
    ShoeRelatedAccessories = "ShoeRelatedAccessories",
}

export const GIFT_WRAPPING_KEY = "Giftwrap";
export const GIFT_WRAPPING_SKU = "8888881";
